<template>
    <div class="main">
        <Header class="is-main"/>
        <router-link to="/" class="main-logo">
            <ul class="logo-list">
                <sequential-entrance :delay="100" animation="logoIn">
                    <li v-for="item in 13" :key="item" class="logo-item"></li>
                </sequential-entrance>
            </ul>
        </router-link>
        <div class="visual-wrapper">
            <Visual/>
        </div>
        <div class="content" id="content">
            <div class="shape-wrapper">
                <div class="shape1"  v-parallax="0.2"></div>
                <div class="shape2"  v-parallax="-0.4"></div>
            </div>
            <scrollama @step-enter="setVisible" :offset="0.8">
                <div class="section01" data-step="a"><About/></div>
                <div class="section02" data-step="b"><Business/></div>
                <div class="section03" data-step="c"><GlobalNetwork/></div>
            </scrollama>
        </div>
    </div>
</template>

<script>
import 'intersection-observer'
import Scrollama from 'vue-scrollama'
import Header from '@/components/common/Header'
import Visual from '@/components/main/Visual'
import About from '@/components/main/About'
import Business from '@/components/main/Business'
import GlobalNetwork from '@/components/main/GlobalNetwork'

export default {
    name: 'Main',
    components: { Scrollama, Header, Visual, About, Business, GlobalNetwork },
    metaInfo: {
        meta: [
            { name: 'description', content: '진보된 이커머스 플랫폼, 큐브플랫폼' },
            { name: 'property="og:description"', content: '진보된 이커머스 플랫폼, 큐브플랫폼' }
        ]
    },
    methods: {
        setVisible: function (el) {
            el.element.classList.add('is-active')
        },
        sectionDown: function (e) {
            var trigger = '' || document.getElementsByClassName('scroll-down')[0]
            var visual = '' || document.getElementsByClassName('visual')[0]
            var slideDown = this._.throttle(function () {
                trigger.click()
            }, 500)
            if (window.pageYOffset < visual.scrollHeight * 0.8) {
                if (e.deltaY < 0) {
                    console.log('scrolling up')
                }
                if (e.deltaY > 0) {
                    console.log('scrolling down')
                    slideDown()
                }
            }
        }
    },
    mounted: function () {
        var visual = document.getElementsByClassName('visual')[0]
        var scrollDown = document.getElementsByClassName('scroll-down')[0]
        setTimeout(function () {
            visual.style.height = window.innerHeight + 'px'
            scrollDown.style.display = 'block'
        }, 5)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes logoIn {
    0% {transform: translateX(30px); opacity: 0;}
    100% {transform: translateX(0); opacity: 1;}
}
.logoIn {
    position: relative;
    animation: logoIn 750ms cubic-bezier(0.39, 0.575, 0.565, 1);
}
.visual-wrapper {
    // overflow: hidden;
    position: relative;
    width: 100%;
    // height: 100vh;
    // height: calc(var(--vh, 1vh) * 100);
}
@include over-desktop {
    .content {
        overflow: hidden;
    }
    .shape-wrapper {
        position: relative;
        width: 1200px;
        height: 100%;
        z-index: -1;
        margin: 0 auto;
        .shape1 {
            position: absolute;
            top: 50px;
            right: -12%;
            width: 229px;
            height: 174px;
            background: url(../assets/image/main/shape_01.png) no-repeat center;
            background-size: 100% auto;
        }
        .shape2 {
            position: absolute;
            top: 680px;
            left: -14%;
            width: 360px;
            height: 290px;
            background: url(../assets/image/main/shape_02.png) no-repeat center;
            background-size: 100% auto;
            transform: translateY(200px);
        }
    }
    .main-logo {
        position: absolute;
        top: 75px;
        left: 60px;
        z-index: 10;
        width: 155px;
        height: 64px;
        transform: translateY(-50%);
        .logo-list {
            transform: scale(0.85);
            transform-origin: center left;
            .logo-item:nth-child(1) {
                position: absolute;
                top: 0;
                left: 0;
                width: 58px;
                height: 64px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
            }
            .logo-item:nth-child(2) {
                position: absolute;
                top: 0;
                left: 58px;
                width: 26px;
                height: 44px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-x: -58px;
            }
            .logo-item:nth-child(3) {
                position: absolute;
                top: 0;
                left: 84px;
                width: 26px;
                height: 44px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-x: -84px;
            }
            .logo-item:nth-child(4) {
                position: absolute;
                top: 0;
                left: 110px;
                width: 26px;
                height: 44px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-x: -110px;
            }
            .logo-item:nth-child(5) {
                position: absolute;
                top: 0;
                left: 136px;
                width: 19px;
                height: 44px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-x: -136px;
            }
            .logo-item:nth-child(6) {
                position: absolute;
                top: 44px;
                left: 58px;
                width: 14px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -58px;
            }
            .logo-item:nth-child(7) {
                position: absolute;
                top: 44px;
                left: 72px;
                width: 12px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -72px;
            }
            .logo-item:nth-child(8) {
                position: absolute;
                top: 44px;
                left: 84px;
                width: 12px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -84px;
            }
            .logo-item:nth-child(9) {
                position: absolute;
                top: 44px;
                left: 96px;
                width: 12px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -96px;
            }
            .logo-item:nth-child(10) {
                position: absolute;
                top: 44px;
                left: 108px;
                width: 12px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -108px;
            }
            .logo-item:nth-child(11) {
                position: absolute;
                top: 44px;
                left: 120px;
                width: 12px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -120px;
            }
            .logo-item:nth-child(12) {
                position: absolute;
                top: 44px;
                left: 132px;
                width: 12px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -132px;
            }
            .logo-item:nth-child(13) {
                position: absolute;
                top: 44px;
                left: 144px;
                width: 11px;
                height: 20px;
                background: url(../assets/image/logo/logo_white.png) no-repeat;
                background-position-y: -44px;
                background-position-x: -144px;
            }
        }
    }
}
@include under-tablet {
    .main-logo {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Main.vue